import { Box, Typography, Link } from '@mui/material';
import { EXTERNAL_LINK_URL } from 'src/commons/const/externalLinkUrl';

export default function Footer() {
  return (
    <Box
      sx={{
        textAlign: 'center',
        py: 5,
      }}
    >
      <Typography variant="body2" color="text.secondary">
        ©︎ 2025 株式会社SCOTT |{' '}
        <Link
          href={EXTERNAL_LINK_URL.terms}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ color: 'inherit', '&:hover': { textDecoration: 'none' } }}
        >
          利用規約
        </Link>{' '}
        |{' '}
        <Link
          href={EXTERNAL_LINK_URL.privacyPolicy}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ color: 'inherit', '&:hover': { textDecoration: 'none' } }}
        >
          プライバシーポリシー
        </Link>
      </Typography>
    </Box>
  );
}
